import { createContext, useContext } from "react";

export const SearchForCityContext = createContext(null);

export function useSearchForCityContext() {
  return useContext(SearchForCityContext);
}
